<rb-loading-spinner *ngIf="dataLoadingSocEvents" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessageSocEvents && !dataLoadingSocEvents">
    <rb-callout type="warning">
        No data for "High State of Charge Events" chart.
    </rb-callout>
</div>
<div id="soc-events-high-ef-chart"></div>
<div class="p-2" *ngIf="!dataLoadingSocEvents && !errorMessageSocEvents">
    <div class="shaded-container ">
        Distribution of the number of vehicles which have experienced high state of charge events along with the corresponding value(s) of the selected vehicle(s). A high state of charge event is counted whenever a battery is operated at states of charge above 80%.
    </div>
</div>